<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="explore-guide">
    <vx-card title="Explore Options Guide" v-show="showGuide">
      <!-- <template slot="actions">
        <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey" @click="toggleGuides"></feather-icon>
      </template> -->
      <div class="vx-row">
        <div
          class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base"
          v-for="guide in data"
          :key="guide.title"
        >
          <vx-card
            :title="guide.title"
            :subtitle="guide.subtitle"
            :title-color="guide === selectedGuide ? '#fff' : ''"
            :card-background="guide === selectedGuide ? 'primary' : ''"
          >
            <template slot="actions">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template>
            <p
              class="text-grey mb-4"
            >{{ guide.note }} {{ guide.mode ? 'revenue' : 'quantity sold'}}</p>
            <!-- <h5 class="text-grey">{{ guide.ref }}</h5> -->
            <div class="flex justify-between flex-wrap">
              <vs-switch class="mt-6" color="success" v-model="guide.mode">
                <span slot="on">by $ Sales</span>
                <span slot="off">by Qty Sold</span>
              </vs-switch>
              <vs-button
                class="mt-4 shadow-lg"
                type="gradient"
                :color="guide === selectedGuide ? 'primary' : '#7367F0'"
                :gradient-color-secondary="guide === selectedGuide ? 'primary' : '#CE9FFC'"
                @click="explore(guide)"
              >{{guide === selectedGuide ? 'In Action' : 'Guide'}}</vs-button>
            </div>
          </vx-card>
        </div>

        <!-- <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
                <vx-card>
                    <h5 class="mb-2">{{ card_1.title }}</h5>
                    <p class="text-grey">{{ card_1.subtitle }}</p>
                    <p class="text-grey">{{ card_1.subtitle_2 }}</p>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="mt-4 shadow-lg" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC">Download</vs-button>
                        <vs-button class="mt-4" type="border" color="#b9b9b9">View All</vs-button>
                    </div>
                </vx-card>
        </div>-->
      </div>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    data: { type: Array, required: true }
  },
  data() {
    return {
      selectedGuide: null,
      showGuide: true,
    };
  },
  methods: {
    explore(guide) {
      this.selectedGuide = guide;
      this.$store.commit('setup/[SETUP] SET_SETUP_GUIDE_ON', guide);
    },
  },
  computed: {
  },
  mounted() {
    // this.$store.subscribe((mutation, state) => {
    //   console.log('Guide -> subscribe -> ',mutation.type)
      
    //   if(mutation.type === 'setup/'+SET_SETUP_GUIDE) {
    //     this.selectedGuide = state.guide; 
    //     console.log('Guide -> subscribe -> selectedGuide -> ',this.selectedGuide)
    //   } else if(mutation.type === 'setup/setArtefact') {
    //     if(mutation.payload && mutation.payload.res && mutation.payload.res.index && !mutation.payload.res.error) {
    //       this.showGuide = false;
    //     } else {
    //       this.showGuide = true;
    //     }
    //     console.log('Guide -> subscribe -> showGuide -> ',this.showGuide)
    //   }
    // });
    this.$store.watch((state, getters) => getters['setup/guideOn'],
      (newValue, oldValue) => {
        this.selectedGuide = newValue;
      }
    );   
    this.$store.watch((state, getters) => getters['setup/artefact'],
      (newValue, oldValue) => {
        if(newValue && newValue.res.index && !newValue.res.error) {
          this.showGuide = false;
        } else {
          this.showGuide = true;
        }
        if(newValue.type && newValue.res.error) {
          this.$vs.notify({
                time: 2500,
                title: 'Info',
                text: newValue.res.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        }
      }
    );    
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss">
#explore-guide {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }
}
</style>
